export enum TransportMode {
  unknown = 'unknown',
  none = 'none',
  tram = 'tram',
  bus = 'bus',
  ferry = 'ferry',
  train = 'train',
  taxi = 'taxi',
  walk = 'walk',
  bike = 'bike',
  car = 'car',
}
